import React from 'react'
import { EditCalendar } from '@mui/icons-material'
import { Box, ButtonBase, Typography, useMediaQuery } from '@mui/material'
import { capitalize, upperCase } from 'lodash'

type SupplierInfoTileTileProps = {
  icon: React.ReactNode
  label: string
  value: string
  onClick: () => void
  disabled?: boolean
  isPlaceholder?: boolean
  error?: boolean
  helperText?: string
}

export const SupplierInfoTile: React.FC<SupplierInfoTileTileProps> = ({
  icon,
  label,
  value,
  onClick,
  disabled = false,
  isPlaceholder = false,
  error = false,
  helperText,
}) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const handleClick = () => {
    if (disabled) return
    onClick()
  }

  return (
    <ButtonBase
      onClick={handleClick}
      disabled={disabled}
      sx={{
        width: '100%',
        px: { xs: 1.5, sm: 2 },
        py: { xs: 1, sm: 1 },
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        bgcolor: disabled ? 'action.hover' : 'background.paper',
        border: '1px solid',
        borderColor: error ? 'error.light' : 'transparent',
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        boxShadow: error ? 4 : 0,
        '&:hover': disabled
          ? {}
          : {
              // boxShadow: 2,
              bgcolor: 'action.hover',
            },
        textAlign: 'left',
      }}
    >
      <Box
        sx={{
          color: disabled ? 'text.disabled' : error ? 'error.main' : 'primary.main',
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        {icon}{' '}
        {!isMobile && (
          <Typography variant="caption" color="text.secondary" fontWeight={500} fontSize={12}>
            {capitalize(label)}
          </Typography>
        )}
      </Box>

      {!isMobile && (
        <Typography
          variant="body2"
          color={error ? 'error.main' : isPlaceholder ? 'text.disabled' : 'text.primary'}
          sx={{
            width: '100%',
            wordBreak: 'break-word',
            paddingLeft: 0.5,
          }}
        >
          {value}
        </Typography>
      )}
      {helperText && (
        <Typography
          variant="caption"
          color="error.main"
          sx={{
            width: '100%',
            wordBreak: 'break-word',
            paddingLeft: 0.5,
            mt: 0.5,
          }}
        >
          {helperText}
        </Typography>
      )}
    </ButtonBase>
  )
}
